module.exports = __webpack_public_path__ + "static/eg-3d3e0265fd08766d5fa7765de527d9ef.png";